import classNames from 'classnames';
import React, { SyntheticEvent } from 'react';
import styles from './LikeButton.module.scss';
import Heart from './assets/heart.svg';

interface ILikeButton {
  title: string;
  liked: boolean;
  onClick: (ev: SyntheticEvent) => Promise<void>;
}
export default function LikeButton({ title, liked, onClick }: ILikeButton) {
  return (
    <button
      title={title}
      type="button"
      className={classNames(
        styles.Heart,
        `${liked ? styles.Filled : ''}`
      )}
      onClick={onClick}
    >
      <Heart />
    </button>
  );
}
